import { keepPreviousData, useQuery } from '@tanstack/react-query';

import {
  ClientOnlineCertificatesQueryParams,
  ClientOnlineCertificatesResponseData,
} from '@/types';

import { HttpClient } from '@/network/HttpClient';

export const CLIENT_ONLINE_CERTIFICATES_QUERY_KEY =
  'client_online_certificates';

export const useClientOnlineCertificatesQuery = (
  props: ClientOnlineCertificatesQueryParams,
) => {
  return useQuery({
    queryKey: [
      CLIENT_ONLINE_CERTIFICATES_QUERY_KEY,
      props.fetchUrl,
      props.queryParams,
    ],
    queryFn: () =>
      HttpClient.request<ClientOnlineCertificatesResponseData>({
        method: 'GET',
        url: props.fetchUrl,
        params: props.queryParams,
      }),
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });
};
